
export const DeletionReasons = [
  { value: "not-using", label: "I'm not using the service anymore" },
  { value: "too-expensive", label: "It's too expensive" },
  { value: "missing-features", label: "Missing features I need" },
  { value: "complicated", label: "It's too complicated to use" },
  { value: "different-service", label: "I'm using a different service" },
  { value: "other", label: "Other reason" },
];
